import { StatusInterface } from "../StatusInterface";
import { Status } from "../Status";
import Translator from "../../../../../Translation/Translator";

class Verified extends Status implements StatusInterface  {

  public static statusId: number = 1;

  public getName(): string {
    return Translator.trans("status-verified");
  }

}

export { Verified }
